'use client';
import { useEffect } from 'react';

import { useUser } from '~/app/_ui/shared/UserProvider/UserProvider';
import { setSentryUser } from './sentry';

export function SentryUserSyncer() {
  const user = useUser();

  useEffect(() => {
    setSentryUser({
      id: user.id,
    });
  }, [user.id]);

  return null;
}
